import i18n from "./i18n";
import { Translations } from "./en";

type NestedKeyOf<ObjectType extends object> = {
  [Key in keyof ObjectType & (string | number)]: ObjectType[Key] extends object
    ? `${Key}.${NestedKeyOf<ObjectType[Key]>}`
    : Key;
}[keyof ObjectType & (string | number)];

export type TranslationKey = NestedKeyOf<Translations>;

export function translate(key: TranslationKey, options?: Record<string, unknown>): string {
  return i18n.t(key, options);
}
